<template>
  <div id="app">
    <router-view v-if="isShow"></router-view>
  </div>
</template>

<script>
export default {
  name: "icdi-pcev",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isShow: true,
    };
  },
  methods: {
    reload() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
  },
  created() {},
  beforeUpdate() {
    if (this.$route.meta.name == undefined) {
      document.title = "科创管家";
    } else {
      document.title = this.$route.meta.name;
    }
  },
};
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
}
</style>
